var map = {
	"./01-phone-verse/01-image.webp": 6430,
	"./01-phone-verse/02-home.webp": 4751,
	"./01-phone-verse/03-favorites.webp": 3705,
	"./01-phone-verse/04-login.webp": 1259,
	"./02-optima-medical/01-image.webp": 3125,
	"./02-optima-medical/02-schedule-an-appointment.webp": 8485,
	"./02-optima-medical/03-choose-doctor-of-the-appointment.webp": 742,
	"./02-optima-medical/04-doctors-consultation-page.webp": 4908,
	"./02-optima-medical/05-emergengy-trace.webp": 2322,
	"./04-shoe-revolution/01-image.webp": 4466,
	"./04-shoe-revolution/02-image.webp": 1809,
	"./05-marketing-agency/01-image.webp": 6145,
	"./05-marketing-agency/02-image.webp": 2018,
	"./06-beauty-salon/01-image.webp": 2770,
	"./07-beauty-products/01-image.webp": 9098,
	"./07-beauty-products/02-homepage.webp": 1343,
	"./08-find-coffee-shop/01-image.webp": 3477,
	"./08-find-coffee-shop/02-image.webp": 9654,
	"./08-find-coffee-shop/03-image.webp": 5280,
	"./08-find-coffee-shop/04-image.webp": 6931,
	"./08-find-coffee-shop/05-presentation-webiste.webp": 4134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1489;